import * as React from "react";
import { PayoutContext } from "./PayoutProvider";

export const usePayoutState = () => {
  return React.useContext(PayoutContext);
};
